import AppCuesHook from "./app_cues_hook"
import { NativeSearch, prepareNativeSearch } from "./native_search.mjs"
import { SearchKeyboard, SearchAutofocus } from "./search_keyboard.mjs"
import { SearchDropdown } from "./search_dropdown.mjs"
import { SearchActionViewport } from "./search_action_viewport.mjs"
import hooks from "../_hooks"
import { ActivityFeed } from "./activity_feed_hook"
import { AgGrid } from "./ag_grid_hook"
import { AgGridResponsive } from "./ag_grid_responsive_hook"
import { ClientPortalAgGrid } from "./client_portal_ag_grid_hook"
import { MobileAccountsAgGrid } from "./mobile_accounts_ag_grid_hook"
import { anchorDownload } from "./anchor_download_hook"
import { AppcuesFlowManagerHook } from "./appcues_flow_manager_hook"
import { AttachmentListItem } from "./attachment_list_item"
import { AutoSwitchFlash } from "./auto_switch_flash_hook"
import { autocomplete } from "../_hooks/EnaiaWeb.Surface.Inputs.AutocompleteInput.hooks"
import { autocompleteAutofocusHook } from "./autocomplete_autofocus_hook"
import { BarGraph } from "./bar_graph_hook"
import { blurQueryResult } from "./blur_query_result_hook"
import { Board } from "./board_hook"
import { BrokerImportToggleGroup } from "./broker_import_toggle_group_hook"
import { citySelector } from "./city_selector_hook"
import { CurrencySelector } from "./currency_selector_hook"
import { clientHook } from "./client_hook"
import { CompanyInputHook } from "./company_input_hook"
import { companySelector } from "../_hooks/EnaiaWeb.Surface.Inputs.CompanySelector.hooks"
import { createLiveToastHook } from "../../../deps/live_toast"
import { withInfoFlashAutoDismiss } from "./live_toast_info_flash_auto_dismiss"
import { DateTimeInputClear } from "./date_time_input_clear_hook"
import { ModalDialog, ModalSheetGesture } from "./modal_dialog_hook"
import { ModalSheetScrollOwner } from "./modal_sheet_scroll_owner_hook"
import { CommentComposer } from "./comment_composer_hook"
import { MenuPopup } from "./menu_popup_hook"
import { SelectPopup } from "./select_popup_hook"
import { DispatchInput } from "./dispatch_input"
import { DownloadWithLoadingState } from "./download_with_loading_state_hook"
import { DropdownAutoHide } from "./dropdown_auto_hide_hook"
import { EditGoalCheckboxRow } from "./edit_goal_checkbox_row_hook"
import { editInputBehaviour } from "./edit_input_behaviour"
import { EmailInput } from "./email_input_hook"
import { ExtractionProgressBar } from "./extraction_progress_bar_hook"
import { EmailRecipients } from "./email_recipients_hook"
import { EnableGrantButton } from "./enable_grant_button_hook"
import { FillEnrichedFields } from "./fill_enriched_fields_hook"
import { FormSnapshot } from "./form_snapshot_hook"
import { GenericConfirmDialog } from "./generic_confirm_dialog_hook"
import { Highlight } from "./highlight_hook"
import { ImageFallback } from "./image_fallback_hook"
import { ImageSkeleton } from "./image_skeleton.mjs"
import { ImageHandler } from "./image_handler_hook"
import { infiniteScroll } from "./infinite_scroll_hook"
import { InitCheckout } from "./init_checkout"
import { InitSortable } from "./init_sortable"
// import { LineClamped } from "./line_clamped" // Now using colocated hook
import { logRocketPushSessionOnMount } from "./logrocket_push_session_on_mount_hook"
import { MaybeExpandIframe } from "./maybe_expand_iframe"
import { MeasureHeight } from "./measure_height_hook"
import { ModalCancel } from "./modal_cancel_hook"
import { MonthlyActivityChart } from "./monthly_activity_chart_hook"
import { NavbarScroll } from "./navbar_scroll_hook"
import { neighborhoodSelector } from "./neighborhood_selector_hook"
import { submarketSelector } from "./submarket_selector_hook"
import { NestedForm } from "./nested_form_hook"
import { NewsTab } from "./news_tab_hook"
import { NotificationHook } from "./notification_hook"
import { NotificationPanelHook } from "./notification_panel_hook"
import { NumberInput } from "./number_input_hook"
import { OnEvent } from "./on_event"
import { OnlineUser } from "./online_user"
import { PhoneNumberInput } from "./phone_number_input_hook"
import { placeSelector } from "./place_selector_hook"
import PopoverMenuHook from "./popover_menu_hook"
import PopoverMultiSelectHook from "./popover_multi_select_hook"
import PopoverSelectHook from "./popover_select_hook"
import FilterableSelectPopover from "./filterable_select_popover"
import { ProspectMeetingGraph } from "./prospect_meeting_graph_hook"
import { MobileKanbanInitialColumn } from "./mobile_kanban_initial_column_hook"
import { relativeCalendarTime } from "./relative_calendar_time"
import { ReloadPage } from "./reload_page_hook"
import { ReportPreviewScale } from "./report_preview_scale_hook"
import { BrokerageIntelligenceChart } from "./brokerage_intelligence_chart_hook"
import { ProductTypePieChart } from "./product_type_pie_chart_hook"
import { ProposalProgressChart } from "./proposal_progress_chart_hook"
import { CostComparisonChart } from "./cost_comparison_chart_hook"
import { LeaseTermTrends } from "./lease_term_trends_hook"
import { NERTrends } from "./ner_trends_hook"
import { TransactionValueTrends } from "./transaction_value_trends_hook"
import { RichEditorHooks } from "./rich_editor"
import ScrollTo from "./scroll_to_hook"
import ScrollToTop from "./scroll_to_top_hook"
import { select } from "../_hooks/EnaiaWeb.Surface.Inputs.Select.hooks"
import { Select } from "./select_hook"
import { ServerAutocomplete } from "./server_autocomplete_hook"
import { ShowAccount } from "./show_account_hook"
import { StopClickPropagation } from "./stop_click_propagation"
import { TextAreaAutoResize } from "./text_area_auto_resize_hook"
import { Tooltip } from "./tooltip_hook"
import { TurnstileHook } from "phoenix_turnstile"
import { TwilioDevice } from "./twilio/device"
import { VerificationCodeInput } from "./verification_code_input_hook"
import { YearMonthInput } from "./year_month_input_hook"
import { SimplePDFViewer } from "./simple_pdf_viewer_hook"
import { LeaseReviewPDFViewer } from "./lease_review_pdf_viewer_hook"
import { ScrollIndicator } from "./scroll_indicator_hook"
import { ClientPortalToursListHighlight } from "./client_portal_tours_list_highlight_hook"
import { ClientPortalTransactionsListHighlight } from "./client_portal_transactions_list_highlight_hook"
import { ClientPortalTransactionsMap } from "./client_portal_transactions_map_hook"
import { ClientPortalToursMap } from "./client_portal_tours_map_hook"
import { ClientPortalLocationsMap } from "./client_portal_locations_map_hook"
import { ClientPortalDealLocationMap } from "./client_portal_deal_location_map_hook"
import { ClientPortalLeaseSecurityChart } from "./client_portal_lease_security_chart_hook"
import { ClientPortalUpcomingExpirationsChart } from "./client_portal_upcoming_expirations_chart_hook"
import { ClientPortalLocationsBySizeChart } from "./client_portal_locations_by_size_chart_hook"
import { SurveyOptionsMap } from "./survey_options_map_hook"
import { RevealOnMount } from "./reveal_on_mount_hook"
import { SurveyOptionsListHover } from "./survey_options_list_hover_hook"

prepareNativeSearch()

const allHooks = {
  SearchKeyboard,
  SearchAutofocus,
  SearchDropdown,
  SearchActionViewport,
  NativeSearch,
  ...hooks,
  ...RichEditorHooks,
  ActivityFeed,
  AgGrid,
  AgGridResponsive,
  ClientPortalAgGrid,
  MobileAccountsAgGrid,
  AnchorDownload: anchorDownload,
  AppcuesFlowManagerHook,
  AppCuesHook,
  AttachmentListItem,
  AutocompleteAutofocus: autocompleteAutofocusHook,
  BarGraph,
  blurQueryResult,
  Board,
  BrokerImportToggleGroup,
  CitySelector: citySelector,
  CurrencySelector,
  ClientAutocomplete: autocomplete,
  ClientHook: clientHook,
  CompanyInputHook,
  CompanySelector: companySelector,
  CustomSelect: select,
  Select,
  DateTimeInputClear,
  ModalDialog,
  ModalSheetGesture,
  ModalSheetScrollOwner,
  CommentComposer,
  MenuPopup,
  SelectPopup,
  DispatchInput,
  DownloadWithLoadingState,
  DropdownAutoHide,
  EditGoalCheckboxRow,
  EditInputBehaviour: editInputBehaviour,
  EmailInput,
  EmailRecipients,
  ExtractionProgressBar,
  EnableGrantButton,
  FillEnrichedFields,
  FormSnapshot,
  GenericConfirmDialog,
  AutoSwitchFlash,
  Highlight,
  ImageFallback,
  ImageSkeleton,
  ImageHandler,
  InfiniteScroll: infiniteScroll,
  InitCheckout,
  InitSortable,
  // LineClamped, // Now using colocated hook
  LiveToast: withInfoFlashAutoDismiss(createLiveToastHook(10000, 3)),
  LogRocketPushSessionOnMount: logRocketPushSessionOnMount,
  MaybeExpandIframe,
  MeasureHeight,
  ModalCancel,
  MonthlyActivityChart,
  NavbarScroll,
  NeighborhoodSelector: neighborhoodSelector,
  SubmarketSelector: submarketSelector,
  NestedForm,
  NewsTab,
  NotificationHook,
  NotificationPanelHook,
  NumberInput,
  OnEvent,
  OnlineUser,
  PhoneNumberInput,
  PlaceSelector: placeSelector,
  PopoverMenu: PopoverMenuHook,
  PopoverMultiSelect: PopoverMultiSelectHook,
  PopoverSelect: PopoverSelectHook,
  FilterableSelectPopover: FilterableSelectPopover,
  ProspectMeetingGraph,
  MobileKanbanInitialColumn,
  RelativeCalendarTime: relativeCalendarTime,
  ReloadPage,
  ReportPreviewScale,
  BrokerageIntelligenceChart,
  ProductTypePieChart,
  ProposalProgressChart,
  CostComparisonChart,
  LeaseTermTrends,
  NERTrends,
  TransactionValueTrends,
  ScrollTo,
  ScrollToTop,
  ServerAutocomplete,
  ShowAccount,
  StopClickPropagation,
  TextAreaAutoResize,
  Tooltip,
  Turnstile: TurnstileHook,
  TwilioDevice,
  VerificationCodeInput,
  YearMonthInput,
  SimplePDFViewer,
  LeaseReviewPDFViewer,
  ScrollIndicator,
  ClientPortalToursListHighlight,
  ClientPortalTransactionsListHighlight,
  ClientPortalTransactionsMap,
  ClientPortalToursMap,
  ClientPortalLocationsMap,
  ClientPortalDealLocationMap,
  ClientPortalLeaseSecurityChart,
  ClientPortalUpcomingExpirationsChart,
  ClientPortalLocationsBySizeChart,
  RevealOnMount,
  SurveyOptionsMap,
  SurveyOptionsListHover,
}

export default allHooks
